import React from "react";
import PatientInfo from "./Patient Infomation/PatientInfo";
import PreviousRx from "./PreviousRx/PreviousRx";
import HistoryAndSymptoms from "./HistoryAndTreatment/HistoryAndTreatment";
import OcularExamination from "./OcularExamination/OcularExamination";
import AdditionalExamination from "./AdditionalExaminations/AdditionalExaminations";
import Refraction from "./Refractions/Refractions";
const NewSightTest = ({ activeTab }) => {
  return (
    <div>
      {/* All child Tabs data Of NewSight Test */}
      {activeTab === "Patient Information" && <PatientInfo />}
      {activeTab === "Previous RX" && <PreviousRx />}
      {activeTab === "History & Symptoms" && <HistoryAndSymptoms />}
      {activeTab === "Ocular Examination" && <OcularExamination />}
      {activeTab === "Additional Examination" && <AdditionalExamination />}
      {activeTab === "Refraction" && <Refraction />}
    </div>
  );
};

export default NewSightTest;
